import { getAxiosObject } from '@/utils/library'
import {
  commonGetters,
  commonActions,
  commonMutations
} from '@/store/store_utils'
import { toStateName } from '@/utils/convert_string'

const dataName = 'measurementResults'
const keys = ['patientId']

const state = {
  [dataName]: [],
  dataIndexedById: {},
  updatedAt: '20101010101010'
}
keys.forEach(key => {
  state[toStateName(key)] = null
})

const getters = {
  ...commonGetters(dataName, ['getDataById', 'getUpdatedAt'], {
    filterDel: true,
    getDataBy: keys
  })
}

const actions = {
  ...commonActions(['setData', 'setUpdatedAt', 'updateAfter']),
  async createIdexxMeasurement(
    { commit },
    { patientId, measurement, measurementResult, measurementResultItems }
  ) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.post('/measurements/idexx', {
        patientId,
        measurement,
        measurementResult,
        measurementResultItems
      })
      if (res.status === 200) {
        commit('updateAfter', [res.data.measurementResult])
        commit(
          'measurementResultItems/updateAfter',
          res.data.measurementResultItems,
          { root: true }
        )
        return 'success'
      }
    } catch (error) {
      if (error.response?.data?.message) {
        return error.response.data.message === 'no data'
          ? `no ${error.response.data.extra}`
          : error.response.data.message
      } else {
        return 'server error'
      }
    }
  },
  async getUnlinkedData({ commit }) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.get('/measurement-results/unlinked-data')
      if (res.status === 200) {
        commit('updateAfter', res.data.measurementResults)
        return 'success'
      }
    } catch {
      return 'failure'
    }
  },
  async delete({ commit }, id) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.delete('/measurement-results', {
        data: { id }
      })
      if (res.status === 200) {
        commit('updateAfter', [res.data.measurementResult])
        commit(
          'measurementResultItems/updateAfter',
          res.data.measurementResultItems,
          { root: true }
        )
        if (res.data.nxMeasurementResult) {
          commit(
            'nxMeasurementResults/updateAfter',
            [res.data.nxMeasurementResult],
            { root: true }
          )
        }
        return 'success'
      }
    } catch (error) {
      if (error.response?.data?.message) {
        if (error.response.data.extra?.data) {
          commit('setData', error.response.data.extra.data)
        }
        return error.response.data.message
      } else {
        return 'server error'
      }
    }
  },
  async update(
    { commit },
    { patientId, measurementResult, measurementResultItems }
  ) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.put('/measurement-results', {
        patientId,
        measurementResult,
        measurementResultItems
      })
      if (res.status === 200) {
        commit('updateAfter', [res.data.measurementResult])
        commit(
          'measurementResultItems/updateAfter',
          res.data.measurementResultItems,
          { root: true }
        )
        return 'success'
      }
    } catch (error) {
      if (error.response?.data?.message) {
        if (error.response.data.message === 'no data in clinic') {
          commit('setData', error.response.data.extra.data)
          return 'no data in clinic'
        } else if (error.response.data.message === 'no data') {
          return `no ${error.response.data.extra}`
        } else if (error.response?.data?.extra) {
          return error.response.data.extra
        } else {
          return error.response.data.message
        }
      } else {
        return 'server error'
      }
    }
  },
  async unlink({ commit }, { id, patientId }) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.put('/measurement-results/unlink', {
        id,
        patientId
      })
      if (res.status === 200) {
        commit('updateAfter', [res.data.measurementResult])
        return 'success'
      }
    } catch (error) {
      if (error.response?.data?.message) {
        if (error.response.data.message === 'no data in clinic') {
          commit('setData', error.response.data.extra.data)
          return 'no data in clinic'
        } else if (error.response.data.message === 'no data') {
          return `no ${error.response.data.extra}`
        } else {
          return error.response.data.message
        }
      } else {
        return 'server error'
      }
    }
  }
}

const mutations = {
  ...commonMutations(dataName, ['setData', 'setUpdatedAt', 'updateAfter'], {
    indexedById: true,
    setDataBy: keys
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
